export const transitions = {
  primary: "333ms ease-in-out",
}
